// Auto-generated by scripts/generate-build-info.js during `npm run build`.
// Do not edit by hand - changes will be overwritten on the next build.
export const BUILD_TIME = "2026-09-24T09:29:17.974Z"
export const BUILD_COMMIT = "84b805b"
